import { ConfirmationDialog } from '@fortem-monorepo/react-ui'
import { MarketSummary } from '@fortem-monorepo/web-sdk'

import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'
import { useRemoveInstrumentFromDisplayMutation } from '@/pages/instruments/market-summary/market-summary.mutations'

export interface RemoveInstrumentFromDisplayDialogProps {
  open: boolean
  onClose: () => void
  mutationParams: { display_id: number; instrument: MarketSummary.Instrument }
}

export const RemoveInstrumentFromDisplayDialog = ({
  mutationParams,
  onClose,
  open,
}: RemoveInstrumentFromDisplayDialogProps) => {
  const { hasWriteAccess } = useMarketSummaryContext()
  const mutation = useRemoveInstrumentFromDisplayMutation(mutationParams.display_id)
  const { instrument } = mutationParams
  return (
    <ConfirmationDialog
      open={open}
      title="Remove Instrument"
      description="The instrument will remain in the catalogue and other displays."
      pending={mutation.isPending}
      valid={hasWriteAccess}
      onClose={() => {
        if (!mutation.isPending) onClose()
      }}
      action={() => {
        if (!hasWriteAccess || mutation.isPending) return
        mutation.mutate({ instrument_id: instrument.instrument_id }, { onSuccess: onClose })
      }}
    >
      <p className="text-sm">{instrument.long_name ?? instrument.unique_identifier ?? instrument.instrument_id}</p>
    </ConfirmationDialog>
  )
}
